import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
const StyledThreadListHeader = styled(UIFlex).withConfig({
  displayName: "StyledThreadListHeader",
  componentId: "pg1ybc-0"
})(["width:100%;height:40px;position:relative;flex-grow:1;flex-shrink:1;margin-left:5px;span.tag{margin-left:8px;}"]);
export default StyledThreadListHeader;